/**
 * Page-load correlation id. Set by the app's page-timing provider on each
 * navigation, and read by the API client to stamp `x-page-load-id` on outgoing
 * requests — so server-side request/RU records (api-metrics) can be joined back
 * to the client page load that triggered them.
 *
 * Design: docs/FeatureDesigns/page-load-perf-drilldown.md (server correlation).
 */

let currentPageLoadId: string | undefined;

export function setCurrentPageLoadId(id: string | undefined): void {
  currentPageLoadId = id;
}

export function getCurrentPageLoadId(): string | undefined {
  return currentPageLoadId;
}
